<template>
  <v-container grid-list-md v-show="false">
    <v-layout row wrap id="printProposta">
      <v-flex xs12 sm4 lg3>
        <img src="../Content/images/logo.png" alt="Orale" width="110px">
      </v-flex>
      <v-flex xs12 sm4 lg4 justify-center>
        <p class="form-titulo" style="text-align: center; font-size: 17px;">RESUMO DA PROPOSTA Nº {{this.financialManagers.proposalNumber}}</p>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <p class="tituloProposta" >Responsável Financieiro</p>
      </v-flex>
      <div class="containerProposta" v-if="this.financialManagers.firstName">
        <p class="subtotal item containerProposta">Nome</p>
        <p class="itemValor">{{this.financialManagers.firstName}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.cpf">
        <p class="subtotal item containerProposta">CPF</p>
        <p class="itemValor">{{this.financialManagers.cpf}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.email">
        <p class="subtotal item containerProposta">E-mail</p>
        <p class="itemValor">{{this.financialManagers.email}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Tel. Fixo</p>
        <p class="itemValor">{{this.financialManagers.homePhone}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Celular</p>
        <p class="itemValor">{{this.financialManagers.cellPhone}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.rg">
        <p class="subtotal item containerProposta">RG</p>
        <p class="itemValor">{{this.financialManagers.rg}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.rgEmitter">
        <p class="subtotal item containerProposta">Org. Emissor</p>
        <p class="itemValor">{{this.financialManagers.rgEmitter}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.dateOfBirth">
        <p class="subtotal item containerProposta">Data de Nascimento</p>
        <p class="itemValor">{{formatDateBrz(this.financialManagers.dateOfBirth)}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.motherName">
        <p class="subtotal item containerProposta">Nome da Mãe</p>
        <p class="itemValor">{{this.financialManagers.motherName}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.maritalStatus">
        <p class="subtotal item containerProposta">Estado Civil</p>
        <p class="itemValor">{{this.financialManagers.maritalStatus}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.gender">
        <p class="subtotal item containerProposta">Sexo</p>
        <p class="itemValor">{{this.financialManagers.gender === 0 ? "FEMININO" : "MASCULINO"}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.matricula">
        <p class="subtotal item containerProposta">Matricula</p>
        <p class="itemValor">{{this.financialManagers.matricula}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.susNumber">
        <p class="subtotal item containerProposta">Cartão do SUS</p>
        <p class="itemValor">{{this.financialManagers.susNumber}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.formOfPayment">
        <p class="subtotal item containerProposta">Cartão do SUS</p>
        <p class="itemValor">{{this.financialManagers.formOfPayment === 'BOLETO' ? 'BOLETO' : 'CARTÃO'}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.cep">
        <p class="subtotal item containerProposta">CEP</p>
        <p class="itemValor">{{this.financialManagers.cep}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.address">
        <p class="subtotal item containerProposta">Endereço</p>
        <p class="itemValor">{{this.financialManagers.address}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.addressNumber">
        <p class="subtotal item containerProposta">Número</p>
        <p class="itemValor">{{this.financialManagers.addressNumber}}</p>
      </div>
      <div class="containerProposta" v-if="this.financialManagers.addressComplement">
        <p class="subtotal item containerProposta">Complemento</p>
        <p class="itemValor">{{this.financialManagers.addressComplement}}</p>
      </div>
      <div class="containerProposta" v-if="bairro">
        <p class="subtotal item containerProposta">Bairro</p>
        <p class="itemValor">{{bairro}}</p>
      </div>
      <div class="containerProposta" v-if="cidade">
        <p class="subtotal item containerProposta">Cidade</p>
        <p class="itemValor">{{cidade}}</p>
      </div>
      <div class="containerProposta" v-if="estado">
        <p class="subtotal item containerProposta">Estado</p>
        <p class="itemValor">{{estado}}</p>
      </div>      

      <v-flex xs12 sm12 lg12>
        <br>
        <p class="tituloProposta" >Beneficiários</p>
      </v-flex>
      <div v-if="dependentes.firstName != ''">
        <div class="flex-container" v-for="dependente in dependentes" :key="`${dependente}`">
          <div class="containerProposta">
            <p class="subtotal item containerProposta">Tipo</p>
            <p class="itemValor">{{dependente.isHolder == true ? 'TITULAR' : 'DEPENDENTE'}}</p>
          </div>
          <div class="containerProposta">
            <p class="subtotal item containerProposta">Nome</p>
            <p class="itemValor">{{dependente.firstName}}</p>
          </div>
          <div class="containerProposta">
            <p class="subtotal item containerProposta">Plano</p>
            <p class="itemValor">{{dependente.plans.name}}</p>
          </div>
        </div>
      </div>
      <v-flex xs12 sm12 lg12>
        <br>
        <p class="tituloProposta" >Informações do Plano/Vendedor</p>
      </v-flex>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Registro</p>
        <p class="itemValor">{{this.planoSelecionado.registro}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Plano</p>
        <p class="itemValor">{{this.planoSelecionado.name}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Adesão</p>
        <p class="itemValor">{{this.financialManagers.reteveAdesao == true ? 'RETIDA' : 'NÃO RETIDA'}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Nome Plataforma</p>
        <p class="itemValor">{{this.vendedor.broker.user.name}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Nome Vendedor</p>
        <p class="itemValor">{{this.vendedor.user.name}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Código S4E</p>
        <p class="itemValor">{{this.vendedor.codeS4}}</p>
      </div>
      
      <v-flex xs12 sm12 lg12>
        <br>
        <p class="tituloProposta" >Validação</p>
      </v-flex>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Endereço IP</p>
        <p class="itemValor">{{this.sales.fMIPConfirm}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Data/Hora</p>
        <p class="itemValor">{{formatDateBrz(this.sales.fMConfirm.substring(0, 10))}} às {{ this.sales.fMConfirm.substring(this.sales.fMConfirm.length - 5, 11) }}</p>
      </div>

      <v-flex xs12 sm12 lg12>
        <br>
        <p class="tituloProposta" >Valor Total</p>
      </v-flex>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">{{ this.dependentes.length }}X Plano Dental</p>
        <p class="itemValor">R$ {{this.financialManagers.responsibility.replace('.',',')}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Taxa de Implementação</p>
        <p class="itemValor">R$ {{this.planoSelecionado.taxaImplantacao}}</p>
      </div>
      <div class="containerProposta">
        <p class="subtotal item containerProposta">Total</p>
        <p class="itemValor">R$ {{this.financialManagers.responsibility.replace('.',',')}}</p>
      </div>

      <v-flex xs12 sm12 lg12>
        <br>
        <v-divider></v-divider>
        <br>
      </v-flex>
      <v-flex xs12 sm12 lg12 style="font-size: 11px">
        <p>Atenção à forma de pagamento escolhida:</p>
        <p style="font-weight: bold">BOLETO:</p>
        <p>- Mensal: O boleto físico chegará mensalmente em seu endereço cadastrado. Caso prefira receber o boleto via e-mail entre em contato com a nossa central de atendimento.</p>
        <p>- À vista: Pagamento antecipado de 12 mensalidades em um único boleto, a partir da 13ª mensalidade será enviado mensalmente.</p>
        <br>
        <p style="font-weight: bold">CARTÃO DE CRÉDITO:</p>
        <p>- Recorrente: Será debitado mensalmente em seu cartão de crédito o valor referente a parcela do plano escolhido.</p>
        <p>- Parcelado: Comprometerá o limite do cartão de crédito o valor de 12 mensalidades do plano escolhido parcelado em 12 vezes, a partir da 13ª mensalidade será debitado mensalmente de forma recorrente.</p>
        <p>- À vista: Pagamento antecipado de 12 mensalidades em uma única parcela no cartão de crédito, a partir da 13ª mensalidade será debitado mensalmente de forma recorrente.</p>
      </v-flex>

      <footer>
        <br>
        <br>
        <br>
        <img src="../Content/images/logo-ans.png" width="120px">
      </footer>
    </v-layout>
  </v-container>    
</template>

<script>
  import PH from 'print-html-element'
  import axios from 'axios'
  import { baseApiUrl } from '@/global'
  export default {
    data () {
      return {
        nomeUsuario: '',
        planoSelecionado: [],
        financialManagers: {
          contratanteTitular: true,
          confirmPassword: '',
          password: '',
          rg: '',
          rgEmitter: '',
          homePhone: '',
          cellPhone: '',
          cellPhone2: '',
          email: '',
          cep: '',
          address: '',
          addressType: '',
          addressTypeName: '',
          addressNumber: '',
          addressComplement: '',
          district: '',
          city: '',
          state: '',
          proposalNumber: 0,
          contractNumberS4: '',
          responsibility: '',
          cardNumber: '',
          cardValidity: '',
          cardFlag: '',
          cardDayExpiration: 15,
          dateSignatureContract: '',
          formOfPaymentId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: null,
          maritalStatus: null,
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: '',
          nsu: '',
          planoSelecionado: [],
          typeFm: 'FISICA',
          protocoloCancelamento: '',
          vendedor: '' 
        },
        bairro: '',
        estado: '',
        cidade: '',
        titular: {
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        },
        dependentes: [{
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: '',
          cpf: '',
          motherName: '',
          susNumber: '',
          plansId: ''
        }],
        vendedor: [],
        sales: [],
      }
    },

    mounted: function() {
      if (localStorage.getItem('proposta') != null)
        this.financialManagers = JSON.parse(localStorage.getItem('proposta'))
      this.consultaCEP()
      this.carregaBeneficiarios()
      this.carregaPlano() 
      this.carregaVendedor()
      this.carregaSales()
    },

    methods: {
      print() {
        var opts = {
          /* stylesheets:"<link rel='stylesheet' href='../Content/styles/minify/main.min.css'>", */
          pageTitle: "Proposta Nº "+this.financialManagers.proposalNumber
        }

        PH.printElement(document.getElementById('printProposta'),opts)
      },

      formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      consultaCEP() {
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
          axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep})
          .then(res => {
            if (res.data != null) {
              this.financialManagers.address = res.data.Logradouro
              this.cidade = res.data.Municipio
              this.financialManagers.city = res.data.IdMunicipio
              this.estado = res.data.Uf
              this.financialManagers.state = res.data.IdUf
              this.bairro = res.data.Bairro
              this.financialManagers.district = res.data.IdBairro
              this.financialManagers.addressType = res.data.IdTipoLogradouro
              this.financialManagers.addressTypeName = res.data.TipoLogradouro
            } else {
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.financialManagers.address = ''
              this.cidade = ''
              this.financialManagers.city = ''
              this.estado = ''
              this.financialManagers.state = ''
              this.bairro = ''
              this.financialManagers.district = ''
              this.financialManagers.addressType = ''
            }
          })
        }
      },

      async carregaBeneficiarios() {
        await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.financialManagers.id})
        .then(response => {
          if (response.data) {
            let titular = response.data.dependentes.filter(dependente => dependente.isHolder == true)
            this.titular = titular[0]
            this.dependentes = response.data.dependentes.filter(dependente => dependente.isHolder == false)
          }
        })
      },

      async carregaPlano() {
        await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.financialManagers.id}).then(async res => {
          let plano = res.data.plano
          await axios.get(`${baseApiUrl}Plans?filter[where][id]=${plano.id}`).then(resp => {
            if (res.data != null) {
              this.planoSelecionado.push(
                resp.data[0].value,
                resp.data[0].area_atuacao,
                resp.data[0].qualificacao,
                resp.data[0].registro,
                resp.data[0].name,
                resp.data[0].cobertura,
                resp.data[0].id,
                "",
                resp.data[0].urlMinutaContrato,
                resp.data[0].urlMinutaAditivo,
                resp.data[0].urlManual,
                resp.data[0].urlGuia,
                resp.data[0].urlCobertura
              )
            }            
          })
        })
      },

      async carregaVendedor() {
        await axios.get(baseApiUrl + 'Salesmans/' + this.financialManagers.salesmanId + '?filter={"include":["user", {"broker":"user"}]}')
        .then(response => {
          if (response.data) {
            this.vendedor = response.data
          }
        })
      },

      async carregaSales() {
        await axios.get(baseApiUrl + 'Sales?filter={"where":{"financialManagerId":"' + this.financialManagers.id + '"}}')
        .then(response => {
          if (response.data) {
            this.sales = response.data[0]
          }
        })
      },
    }
  }
</script>

<style>
  .tituloProposta {
    font-size: 15px;
    font-weight: 700;
    color:#797a7a;
    margin-bottom: 5px;  
    text-align: center;  
    border: 1px solid; 
    border-color: #00bd95;
    border-radius: 10px;
    padding: 8px;
  }

  .flexProposta {
    display: flex;
    flex-wrap: nowrap;
  }

  .item {
    margin: 10px auto;
    font-size: 18px;
    color: #00bd95;
  }

  .containerProposta {
    font-size: 15px;
    min-width: auto;
    margin: 5px 20px 0 0;
  }

  .itemValor {
    margin: 5px auto;
    font-size:15px;
    color:#797a7a;
  }

  .flex-container {
    display: flex;
    flex-wrap: nowrap;
  }

  .flex-container > div {
    min-width: auto;
    margin: 5px 20px auto auto;
    font-size:15px;
    color:#797a7a;
  }
</style>
